import { Box, Typography } from "@mui/material";
import { baseTheme } from "../../../themes/shipinsure";
import { statusColors } from "../statusStyles";
import type { ClaimTranslator, ShippingAddress } from "../types";

type ShippingAddressCardProps = {
  address?: ShippingAddress;
  t: ClaimTranslator;
};

export const ShippingAddressCard = ({ address, t }: ShippingAddressCardProps) => {
  if (!address) {
    return null;
  }

  const lines = [
    address.name,
    address.street_address_1,
    address.street_address_2,
    [address.city, address.state_or_province, address.postal_code]
      .filter(Boolean)
      .join(", "),
    address.country,
  ].filter(Boolean) as string[];

  return (
    <Box
      mb="24px"
      sx={{
        border: `1px solid ${statusColors.divider}`,
        borderRadius: "16px",
        padding: "20px",
      }}
    >
      <Typography variant="h6" mb="12px">
        {t("status.shippingAddress")}
      </Typography>
      {lines.map((line) => (
        <Typography key={line} color={baseTheme.colors.textLight}>
          {line}
        </Typography>
      ))}
    </Box>
  );
};
